import React from 'react';
import './base.css';
import Container from './container';
import Navigation from './navigation';
import MobileNavigation from './mobileNavigation';
import Footer from './footer';
import useMedia from '../customHooks/userMedia';

interface Props {
  children: React.ReactNode;
}

const Template: React.FC<Props> = ({ children }) => {
  const isMobile = useMedia('(max-width: 767px)');
  return (
    <Container>
      {isMobile ? <MobileNavigation /> : <Navigation />}
      {children}
      <Footer />
    </Container>
  );
};

export default Template;
